export enum BonusSettlementTab {
    Customer = '',
    Pool = 'pool',
}
